import React, {Component} from "react";
import Alert from "./Alert";
import "./PageBlock.css"

class PageBlock extends Component {
    render() {
        if (this.props.small) {
            return (
                <div className="page-block-sm"><Alert />{this.props.children}</div>
            )
        } else {
            return (
                <div className="page-block"><Alert />{this.props.children}</div>
            )
        }
    }
}

PageBlock.propTypes = {
    small: React.PropTypes.bool
};

PageBlock.defaultProps = {
    small: false
};

export default PageBlock;



// WEBPACK FOOTER //
// ./src/modules/common/PageBlock.js